var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l((_vm.tagsArr),function(tag){return _c('a-tag',[_vm._v(_vm._s(tag))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }